import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  mb: 1.5,
  mx: 'auto',
  maxWidth: (p) => p.spacing(59),
};

export const tabLabel: SxStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.75,
};
